module.exports = "fragment ShelfPartner on ClubPartner {\n  slug\n  name\n  logo\n  logo_negative\n  colors {\n    primary\n  }\n}\n\nquery Shelves ($quantity: Int = 10) {\n  partners (limit: $quantity, page: 1, is_main: \"1\") {\n    total\n    data {\n      ...ShelfPartner\n    }\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/PartnerPagination.graphql
// module id = 2005
// module chunks = 1610